<template>
    <div class="Item">
        <headerItem msg="2024年月贷款概况" bgColor="" titleBeforeColor="" rightIcon=""></headerItem>
        <div class="grid-container">
            <div ref="chart" id="chart" style="width: 100%; min-height: 320px;" class="flex-1 charts-style"></div>
        </div>
    </div>
</template>

<script>
import headerItem from '../components/headerItem.vue';
import * as echarts from 'echarts';
export default {
    name: '',
    components: {
        headerItem
    },
    props: {
        current: Number,
    },
    watch: {
        current(newVal, oldVal) {
            if (newVal === 1) {
                this.listData = this.listData1
            } else if (newVal === 0) {
                this.listData = this.listData0
            }
			this.initChart(this.listData);
        }
    },
    data() {
        return {
            chart: null,
            listData: {},
			listData0: {
				data1: [393, 438, 485],
				data2: [200, 382, 102]
			},
			listData1:
			{
				data1: [297243670.2, 329361275.3, 378624571.9],
				data2: [1128074933, 1166119933, 1270689933]
			}
        }
    },
    created() {
		this.listData = this.listData0
	},
    mounted() {
        this.initChart(this.listData);
    },
    methods: {
        initChart(list) {
            const myChart = echarts.init(this.$refs.chart);
            const option = {
                tooltip: {},
                grid: {
                    left: '5%',
                    right: '5%',
                    top: '20%',
                    bottom: '5%',
                    containLabel: true,
                },
                legend: {
                    align: "left",
                    left: '10%',
                    top: '5%',
                    type: 'plain',
                    textStyle: {
                        color: '#7ec7ff',
                        fontSize: 6
                    },
                    itemGap: 6,
                    data: ['月末贷款余额', '月末授信额度'],
                    itemHeight: 6,
                },
                xAxis: [{
                    type: 'category',
                    boundaryGap: true,
                    axisLine: { //坐标轴轴线相关设置。数学上的x轴
                        show: true,
                        lineStyle: {
                            color: '#f9f9f9'
                        },
                    },
                    axisLabel: { //坐标轴刻度标签的相关设置
                        textStyle: {
                            color: '#d1e6eb',
                            margin: 15,
                        },
                    },
                    axisTick: {
                        show: false,
                    },
                    data: ['1月', '2月', '3月'],
                }],
                yAxis: [{
                    type: 'value',
                    min: 0,
                    // max: 140,
                    splitNumber: 7,
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#0a3256'
                        }
                    },
                    axisLine: {
                        show: false,
                    },
                    axisLabel: {
                        margin: 20,
                        textStyle: {
                            color: '#d1e6eb',

                        },
                    },
                    axisTick: {
                        show: false,
                    },
                }],
                series: [{
                    name: '月末贷款余额',
                    type: 'line',
                    smooth: true, //是否平滑曲线显示
                    symbol: 'circle',  // 默认是空心圆（中间是白色的），改成实心圆
                    showAllSymbol: true,
                    symbol: 'emptyCircle',
                    symbolSize: 3,
                    lineStyle: {
                        normal: {
                            color: "#28ffb3", // 线条颜色
                        },
                        borderColor: '#f0f'
                    },
                    label: {
                        show: true,
                        position: 'top',
                        textStyle: {
                            color: '#fff',
                        }
                    },
                    itemStyle: {
                        normal: {
                            color: "#28ffb3"
                        }
                    },
                    tooltip: {
                        show: false
                    },
                    areaStyle: { //区域填充样式
                        normal: {
                            //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgba(0,154,120,1)'
                            },
                            {
                                offset: 1,
                                color: 'rgba(0,0,0, 0)'
                            }
                            ], false),
                            shadowColor: 'rgba(53,142,215, 0.9)', //阴影颜色
                            shadowBlur: 20 //shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
                        }
                    },
                    data: list.data1
                }, {
                    name: '月末授信额度',
                    type: 'bar',
                    barWidth: 10,
                    tooltip: {
                        show: false
                    },
                    label: {
                        show: true,
                        position: 'top',
                        textStyle: {
                            color: '#fff',
                        }
                    },
                    itemStyle: {
                        normal: {
                            color: function (params) {
                                var colorList = ['#0ec1ff', '#10cdff', '#12daff', '#15ebff', '#17f8ff', '#1cfffb', '#1dfff1'];
                                return colorList[params.dataIndex];
                            }
                        }
                    },
                    data: list.data2
                }]
            }
            myChart.setOption(option);
            window.onresize = function () {
                myChart.resize();
            }
        }
    },
    beforeDestroy() {
        if (this.chartInstance) {
            this.chartInstance.dispose(); // 清理chart实例
        }
    },
}
</script>

<style lang="less" scoped>
.Item {
    .grid-container {
        width: 100%;
        // margin: 10px auto 0;
        display: grid;
        grid-template-columns: 1fr;
        /* 这表示列的大小为1fr */
        grid-template-rows: 1fr;
        /* 这表示行的大小为1fr */
        justify-items: center;

        .grid-item {
            box-sizing: border-box;
            border: 1px solid #e4e4e4;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            text-align: center;
            padding: 20px;
        }
    }
}
</style>
